import React from "react";
import { Paper, Stack } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { FileExplorerProvider } from "../FileExplorerContext";
import { FileDropZone } from "../FileDropZone";
import { FileUploadLoadingOverlay } from "./FileUploadLoadingOverlay";
import { AccountPageLayout } from "components/common/AccountPageLayout";
import { SelectFileTypeDropdown } from "./SelectFileTypeDropdown";
import { RequireAdmin } from "src/routes/authentication";

const FileUploadContent: React.FC = () => {
  const { t } = useTenantTranslation();
  return (
    <AccountPageLayout title={t("uploadFile")}>
      <RequireAdmin>
        <Stack py={1}>
          <SelectFileTypeDropdown />
        </Stack>
      </RequireAdmin>
      <Paper
        elevation={1}
        sx={{
          display: "flex",
          flexDirection: "column",
          position: "relative",
          mt: 2,
        }}
      >
        <FileDropZone />
        <FileUploadLoadingOverlay />
      </Paper>
    </AccountPageLayout>
  );
};

export const FileUploadPage: React.FC = () => {
  return (
    <FileExplorerProvider>
      <FileUploadContent />
    </FileExplorerProvider>
  );
};
